"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExecutableAction = void 0;
const package_1 = require("../package");
const titan_ads_1 = require("../ontologies/titan-ads");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
const models_1 = require("lincd/lib/models");
const NodeValuesSet_1 = require("lincd/lib/collections/NodeValuesSet");
const Action_1 = require("lincd-schema/lib/shapes/Action");
const SHACL_1 = require("lincd/lib/shapes/SHACL");
let ExecutableAction = class ExecutableAction extends Action_1.Action {
    get method() {
        return this.getValue(titan_ads_1.titanAds.method);
    }
    set method(val) {
        this.overwrite(titan_ads_1.titanAds.method, new models_1.Literal(`${val}`));
    }
    get targetShape() {
        return this.getOneAs(titan_ads_1.titanAds.targetShape, SHACL_1.NodeShape);
    }
    set targetShape(val) {
        this.overwrite(titan_ads_1.titanAds.targetShape, val ? val.node : null);
    }
    get parameters() {
        return this.getAll(titan_ads_1.titanAds.parameters);
    }
};
exports.ExecutableAction = ExecutableAction;
ExecutableAction.targetClass = titan_ads_1.titanAds.ExecutableAction;
ExecutableAction.STATUS_DECLINED = 4;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: titan_ads_1.titanAds.method,
        required: true,
        dataType: xsd_1.xsd.string,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ExecutableAction.prototype, "method", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.targetShape,
        required: true,
    }),
    __metadata("design:type", SHACL_1.NodeShape),
    __metadata("design:paramtypes", [SHACL_1.NodeShape])
], ExecutableAction.prototype, "targetShape", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: titan_ads_1.titanAds.parameters,
    }),
    __metadata("design:type", NodeValuesSet_1.NodeValuesSet),
    __metadata("design:paramtypes", [])
], ExecutableAction.prototype, "parameters", null);
exports.ExecutableAction = ExecutableAction = __decorate([
    package_1.linkedShape
], ExecutableAction);
//# sourceMappingURL=ExecutableAction.js.map